import { mockApiReturn } from '../utils/helper';
import axiosClient from './axiosClient';

export const talentAnalyticApi = {
  getYearInSalaryGrade: (body) => {
    const url = `/yisg-aging-report/by-salary-grade`;
    return axiosClient.post(url, body);
  },

  getAnalyticsFilters: (params, roleId) => {
    const url = `/analytics-filters`;
    return axiosClient.get(url, {
      params,
      headers: {
        role: roleId,
      },
    });
  },

  getTenureFiltersOptions: () => {
    // const url = `/talent-review-dashboard/get-filters`;
    return null;
    // return axiosClient.get(url);
  },

  getYearInPositionTenureInsights: (body, roleId) => {
    const url = `/yisg-aging-report/by-position`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  getReportTenureInsights: () => {
    const url = `/analytics-report/reports`;
    return mockApiReturn(url, {
      data: [
        {
          name: 'Minh Nguyen',
          staff_id: 'EMP001',
          years_in_salary_grade: 3,
          salary_grade: 'G7',
          years_in_position: 2,
          years_in_business: 9,
          critical_position_category: 'Medium',
          role_level: 'Senior Manager',
          age: 34,
          gender: 'Female',
          nationality: 'British',
          state_of_birth: 'London',
          language: 'English, French',
          current_business: 'Human Resources',
          current_sector: 'Corporate Services',
          current_opu: 'Europe',
          current_division: 'Talent Management',
          current_job_family: 'HR',
          current_sub_job_family: 'Talent Development',
          current_function: 'HR Manager',
          years_to_retire: 31,
          work_location: 'London',
          successor: 'Yes',
          readiness: 'Ready in 1-2 Years',
          top_talent_status: 'High Potential',
        },
      ],
      total: 1,
    });
    // return axiosClient.post(url, body, {
    //   headers: {
    //     role: roleId,
    //   },
    // });
  },

  exportReportTenureInsight: (body, roleId) => {
    const url = `/analytics-report/export-reports`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchBusinessUnitList: (roleId) => {
    const url = `/analytics-filters/business-unit`;
    return axiosClient.get(url, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchReportByYearInBusinessUnit: (body) => {
    const url = `/yisg-aging-report/by-business-unit`;
    return axiosClient.post(url, body);
  },

  fetchViewDetailsByReportType: (body) => {
    const url = `/tenure-insights/get-view-details-by-report`;
    return axiosClient.post(url, body);
  },

  fetchReportTenureInsightUrl: (body) => {
    const url = `/tenure-insights/get-export-by-report`;
    return axiosClient.post(url, body);
  },

  fetchTotalPositionStatusInPositionInsights: () => {
    const url = `/position-insights/total-positions-status`;
    return axiosClient.post(url);
  },

  fetchPositionStatusInPositionInsights: (body) => {
    const url = `/position-insights/position-status`;
    return axiosClient.post(url, body);
  },

  fetchYearsOfPositionPositionInsights: (body) => {
    const url = `/position-insights/get-report-by-years-of-position`;
    return axiosClient.post(url, body);
  },

  fetchReportPositionInsights: (body, roleId) => {
    const url = `/position-insights/get-view-details-by-report`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchReportPositionInsightsUrl: (body, roleId) => {
    const url = `/position-insights/get-export-by-report`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchTopTalentCategoryDynamics: (body, roleId) => {
    const url = `/tenure-insights/top-talent-categorisation`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchSuccessorApproachingRetirement: (body, roleId) => {
    const url = `yisg-aging-report/successor-approaching-retirement`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchSPWithoutSuccessor: (roleId) => {
    const url = `/position-insights/get-sp-without-successor`;
    return axiosClient.get(url, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchSPWithoutSuccessorReports: (body, roleId) => {
    const url = `/position-insights/get-sp-without-successor-reports`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchSPWithoutSuccessorReportsExel: (body, roleId) => {
    const url = `/position-insights/get-sp-without-successor-excel`;
    return axiosClient.post(url, body, {
      headers: {
        role: roleId,
      },
    });
  },

  fetchYearsOfPositionOptionsPositionInsights: () => {
    const url = `/position-insights/get-years-in-position-options`;
    return axiosClient.get(url);
  },
};
